<template>
  <div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color="#324157"
             text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                  {{ threeItem.title }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                {{ subItem.title }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
  import bus from './bus'
  export default {
    data () {
      return {
        collapse: true,
        items: [
          {
            icon: 'el-icon-s-home',
            index: '0',
            title: '管理主页',
            subs: [
              {
                index: 'bigScreen2',
                title: '监测大屏'
              },
              {
                index: 'bigScreen',
                title: '运维大屏'
              },
              {
                index: 'home',
                title: '总体态势'
              },
              {
                index: 'chartsAnalyse',
                title: '统计分析'
              },
              {
                index: 'realTimeMonitoring',
                title: '实时监控'
              }
            ]
          },
          {
            icon: 'el-icon-s-flag',
            index: 'alarmPointManage',
            title: '警报点管理'
          },
          {
            icon: 'el-icon-s-promotion',
            index: '1',
            title: '警报记录',
            subs: [
              {
                index: 'sendRecord',
                title: '发送记录'
              },
              {
                index: 'returnRecord',
                title: '回示记录'
              },
            ]
          },
          {
            icon: 'el-icon-bell',
            index: '2',
            title: '告警管理',
            subs:[
              {
                index: 'alarmManage',
                title: '异常告警'
              },
              {
                index: 'ringingState',
                title: '鸣响状态'
              },
            ]
          },
          {
            icon:'el-icon-s-marketing',
            index:'stateManagement',
            title:'状态管理'
          },
          {
            icon: 'el-icon-s-order',
            index: '3',
            title: '巡检/维修',
            subs: [
              {
                index: 'InspectionCycle',
                title: '巡检任务规划'
              },
              {
                index: 'taskAssignment',
                title: '任务分配',
                subs: [
                  {
                    index: 'inspectTaskAssignment',
                    title: '巡检任务分配'
                  },
                  {
                    index: 'repairTaskAssignment',
                    title: '维修任务分配'
                  },
                  {
                    index: 'taskConfirm',
                    title: '任务确认情况'
                  },
                ]
              },
              {
                index: 'inspectRecord',
                title: '巡检记录'
              },
              {
                index: 'updateRecord',
                title: '升级记录'
              },
              {
                index: 'reportRecord',
                title: '报修记录'
              },
              {
                index: 'repairRecord',
                title: '维修记录'
              }
            ]
          },
          {
            icon: 'el-icon-s-help',
            index: '4',
            title: '系统',
            subs: [
              {
                index: 'databaseBackup',
                title: '数据库备份'
              },
              {
                index: 'userManage',
                title: '账户管理'
              }
            ]
          },
          {
            icon: 'el-icon-setting',
            index: '5',
            title: '设置',
            subs: [
              {
                index: 'dataUpdate',
                title: '数据更新设置'
              },
              {
                index: 'alarmRuleManage',
                title: '告警规则设置'
              },
              {
                index: 'areaSetting',
                title: '区域设置'
              },
              {
                index:'sensorSetting',
                title:'传感器设置'
              },
              {
                index:'cameraSetting',
                title:'摄像头设置'
              },
              {
                index:'portSetting',
                title:'串口设置'
              },
              // {
              //   index:'MapTest',
              //   title:'地图测试'
              // }
            ]
          }
        ]
      }
    },
    computed: {
      onRoutes () {
        return this.$route.path.replace('/', '')
      }
    },
    created () {
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', msg => {
        this.collapse = msg
      })
    }
  }
</script>

<style scoped>
  .sidebar{
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom:0;
    overflow-y: scroll;
  }
  .sidebar::-webkit-scrollbar{
    width: 0;
  }
  .sidebar-el-menu:not(.el-menu--collapse){
    width: 250px;
  }
  .sidebar > ul {
    height:100%;
  }
</style>
